import React from 'react';
import { MenuIcon as HeroMenuIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type MenuIconProps = Omit<IconProps, 'children'>;

export const MenuIcon: React.FC<MenuIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroMenuIcon />
        </Icon>
    );
};
